import React, { useState } from 'react';
import { faqs, reviews } from '@/data/mockData';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const AccordionItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b-2 border-black group">
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="w-full py-8 flex justify-between items-center text-left focus:outline-none"
        aria-expanded={isOpen}
      >
        <span className={`text-xl md:text-2xl font-black uppercase tracking-tight transition-colors ${isOpen ? 'prism-text' : 'group-hover:text-gray-500'}`}>{question}</span>
        <div className={`w-10 h-10 border-2 border-black flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-black text-white rotate-180' : ''}`}>
          <SafeIcon icon={FiIcons.FiChevronDown} className="text-xl" />
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100 pb-8' : 'max-h-0 opacity-0'}`}>
        <p className="text-lg md:text-xl text-gray-600 font-medium leading-relaxed max-w-2xl">{answer}</p>
      </div>
    </div>
  );
};

const InfoSection = ({ onNewsletterSuccess }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    setTimeout(() => {
      onNewsletterSuccess();
      setEmail('');
      setSubmitting(false);
    }, 1000);
  };

  return (
    <section className="py-32 px-6 max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-24 items-start">
        <div className="lg:col-span-5">
          <div className="mb-16">
            <h2 className="text-5xl md:text-7xl font-black tracking-tighter uppercase leading-none mb-6">The<br/>Verdict.</h2>
            <p className="text-lg text-gray-500 font-medium">Unfiltered feedback from our global community.</p>
          </div>
          
          <div className="space-y-8">
            {reviews.map((rev) => (
              <div key={rev.id} className="bg-white p-10 border-2 border-black relative group hover:shadow-[15px_15px_0px_0px_rgba(0,0,0,0.05)] transition-all">
                <div className="absolute -top-4 -right-4 bg-black text-white w-12 h-12 flex items-center justify-center font-black">
                  {rev.rating}.0
                </div>
                <div className="flex gap-1 mb-6">
                  {[...Array(rev.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-black text-black w-4 h-4" />
                  ))}
                </div>
                <p className="text-xl md:text-2xl font-bold leading-tight mb-8">"{rev.text}"</p>
                <div className="flex items-center justify-between">
                  <p className="font-black tracking-[0.2em] text-xs uppercase">— {rev.author}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex gap-8 mb-12 border-b-4 border-black pb-4 overflow-x-auto no-scrollbar">
            <button className="font-black text-[10px] tracking-[0.4em] uppercase border-b-4 border-black pb-2 -mb-5">PRISM FAQ</button>
            <button className="font-black text-[10px] tracking-[0.4em] uppercase text-gray-400 hover:text-black transition-colors pb-2">SHIPPING</button>
            <button className="font-black text-[10px] tracking-[0.4em] uppercase text-gray-400 hover:text-black transition-colors pb-2">WARRANTY</button>
          </div>

          <div className="mb-16">
            {faqs.map((faq, idx) => (
              <AccordionItem key={idx} question={faq.q} answer={faq.a} />
            ))}
          </div>

          <div className="p-12 bg-black text-white relative overflow-hidden group border-2 border-white">
            <div className="relative z-10">
              <h3 className="text-3xl md:text-4xl font-black mb-6 uppercase tracking-tighter">Join The Spectrum.</h3>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4">
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email for studio updates" 
                  className="bg-transparent border-b-2 border-gray-700 px-0 py-4 focus:outline-none focus:border-white transition-all w-full text-lg font-bold uppercase tracking-widest"
                />
                <button 
                  disabled={submitting}
                  className="bg-white text-black px-10 py-4 font-black text-[10px] tracking-[0.3em] uppercase hover:prism-gradient hover:text-white transition-all duration-500 disabled:opacity-50"
                >
                  {submitting ? 'PROCESSING...' : 'SUBSCRIBE'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;